(function() {
  'use strict';

  angular.module('ringbaPortal').component('existingUrlParams', {
    bindings: {
      currentCampaign: '<',
      queryPathMaps: '<',
      onSave: '&',
      onDismiss: '&'
    },
    controller: ExistingUrlParamsController,
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: '/scripts/shared/components/select-url-params/existing-url-params.view.html'
  });

  function ExistingUrlParamsController(
    $filter,
    accountsService,
    campaignServiceNew,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;
    vm.onSubmit = onSubmit;

    function onSubmit() {
      return _linkToCampaign(vm.currentQueryPathMap.id).then(function () {
        toaster.pop('success', $filter('translate')('TAGS_ADDED_SUCCESS'));
        vm.onDismiss({
          $event: {
            queryPathMap: vm.currentQueryPathMap
          }
        });
        vm.onSave();
      }).catch(utils.errorHandler);
    }

    function _linkToCampaign(queryPathMapId) {
      return campaignServiceNew.link(accountsService.currentAccountId, vm.currentCampaign.id, queryPathMapId, 'qpathmaps');
    }

  }
})();
